<template>
    <app-modal
        modal-id="employee-import-modal"
        modal-size="large"
        modal-alignment="top"
        @close-modal="closeModal"
    >
        <template slot="header">
            <h5 class="modal-title">{{ $t('import_employees') }}</h5>
            <button type="button" class="close outline-none" @click="closeModal">
                <span>
                    <app-icon name="x"></app-icon>
                </span>
            </button>
        </template>

        <template slot="body">
            <import-employees @import-success="handleImportSuccess"/>
        </template>
    </app-modal>
</template>

<script>
import ImportEmployees from "../Setting/Import/ImportEmployees";

export default {
    name: "EmployeeImportModal",
    components: {ImportEmployees},
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        closeModal() {
            $('#employee-import-modal').modal('hide');
            this.$emit('input', false);
            this.$emit('close');
        },
        handleImportSuccess() {
            this.$emit('import-complete');
            this.$hub.$emit('reload-employee-table');
        }
    }
};
</script>
